function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M337.6,158.6v-0.4V97.8c0-27.2-19.2-37.2-37.2-37.2h-228c-18,0-37.2,9.6-37.2,37.2v60.4v0.4c-18,2-35.2,14-35.2,41.6v47.2 c0,8,6.4,14.4,14.4,14.4h4.8V299c0,8,6.4,14.4,14.4,14.4h13.6c8,0,14.4-6.4,14.4-14.4v-37.6h250.8V299c0,8,6.4,14.4,14.4,14.4 h13.6c8,0,14.4-6.4,14.4-14.4v-37.6h4.8c8,0,14.4-6.4,14.4-14.4v-46.8C372.8,172.6,355.6,160.6,337.6,158.6z M48.8,97.8h0.8 C49.6,79,62,75,72.4,75h228c10.4,0,22.8,4,22.8,22.8v60.4h-10.8v-34.4c0-8-6.4-14.4-14.4-14.4h-88c-8,0-14.4,6.4-14.4,14.4v34.4 h-16.8v-34.4c0-8-6.4-14.4-14.4-14.4h-88c-8,0-14.4,6.4-14.4,14.4v34.4H48.8V97.8z M298,123.8v34.4h-88v-34.4H298z M165.2,123.8 v34.4h-88v-34.4H165.2z M46.8,299H33.2v-37.6h13.6V299z M339.6,299H326v-37.6h13.6V299z M358.4,247.4h-18.8H326H46.8H33.2H14 v-21.2h344.4V247.4z M358.4,211.8H14v-11.6c0-24,17.6-27.6,27.6-27.6h7.6h27.6h88H210h88h25.2h7.6c10.4,0,27.6,3.6,27.6,27.6 V211.8z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 374 374",
    style: {
      "enableBackground": "new 0 0 374 374"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/bed.0c61a0e0.svg";
export { SvgComponent as ReactComponent };